import { render, staticRenderFns } from "./Osa008.vue?vue&type=template&id=97325298&scoped=true"
var script = {}
import style0 from "./Osa008.vue?vue&type=style&index=0&id=97325298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97325298",
  null
  
)

export default component.exports